import React, { useEffect } from 'react';
import { Outlet, useNavigate } from "react-router-dom";
import { userAppData } from '../MainApp.js';
import './reprographics.css';

/**
 * Guards and renders the Reprographics module routes.
 */
export default function Reprographics() {
    const navigate = useNavigate();
    const reproPerms = Number(userAppData?.reproRequestsData?.perms ?? 0);

    useEffect(() => {
        if (reproPerms === 0) {
            navigate("/app");
        }
    }, [navigate, reproPerms]);

    return (
        <div className='main_div'>
            <Outlet />
        </div>
    );
}
